import { render, staticRenderFns } from "./SecondaryCommissionA.vue?vue&type=template&id=67fdad08&scoped=true"
import script from "./SecondaryCommissionA.vue?vue&type=script&lang=js"
export * from "./SecondaryCommissionA.vue?vue&type=script&lang=js"
import style0 from "./SecondaryCommissionA.vue?vue&type=style&index=0&id=67fdad08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fdad08",
  null
  
)

export default component.exports